// src/components/CustomSelectDropdown.jsx
import React, { useState, useEffect, useRef } from "react";
import {
  ChevronDown,
  ChevronUp,
  Search,
} from "lucide-react";

const CustomSelectDropdown = ({
  label,
  value,
  options = [],
  onChange,
  placeholder = "Select option",
  leftIcon: LeftIcon,       // Lucide icon passed from parent
  optionIcon: OptionIcon,   // Lucide icon for options
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const ref = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const filteredOptions = options.filter((item) =>
    item.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="w-full relative" ref={ref}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
        </label>
      )}

      {/* Select Box */}
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full px-4 py-3 border border-gray-300 rounded-xl bg-white text-gray-800 flex items-center justify-between focus:ring-2 focus:ring-indigo-500"
      >
        <div className="flex items-center gap-2">
          {/* LEFT ICON */}
          {LeftIcon && <LeftIcon className="w-5 h-5 text-gray-600" />}
          <span>{value || placeholder}</span>
        </div>

        {/* RIGHT ARROW */}
        {open ? (
          <ChevronUp className="w-5 h-5 text-gray-700" />
        ) : (
          <ChevronDown className="w-5 h-5 text-gray-700" />
        )}
      </button>

      {/* Dropdown */}
      {open && (
        <div className="absolute mt-2 w-full z-50 bg-white border border-gray-200 rounded-xl shadow-lg p-2">
          {/* Search Bar */}
          <div className="flex items-center px-3 py-2 bg-gray-100 rounded-lg mb-2">
            <Search className="w-4 h-4 text-gray-500 mr-2" />
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search..."
              className="bg-transparent w-full outline-none text-gray-700"
            />
          </div>

          {/* Options */}
          <div className="max-h-48 overflow-y-auto custom-scrollbar">
            {filteredOptions.length === 0 ? (
              <p className="text-gray-500 text-sm px-3 py-2">No results found</p>
            ) : (
              filteredOptions.map((item) => (
                <div
                  key={item}
                  onClick={() => {
                    onChange(item);
                    setOpen(false);
                    setSearch("");
                  }}
                  className="px-4 py-2 rounded-lg cursor-pointer hover:bg-indigo-50 flex items-center gap-2 text-gray-800"
                >
                  {/* ICON FOR EACH OPTION */}
                  {OptionIcon && (
                    <OptionIcon className="w-4 h-4 text-indigo-500" />
                  )}

                  {item}
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomSelectDropdown;
